export default "__VITE_ASSET__DKIXGvP7__"